<!--<c-footer>-->
  <div>
    <span class="text-end"> &copy; {{date.getFullYear()}}</span>
  </div>
  <!-- <div class="ms-auto">
    Powered by
    <a href="https://coreui.io/pro/angular" target="_blank">
      <span> CoreUI for Angular</span>
    </a>
  </div> -->
<!--</c-footer>-->
